import './SectionOneMobile.css';

import React from 'react';

import { Link, useNavigate } from 'react-router-dom';

const SectionOneMobile = () => {
  const navigate = useNavigate();
  return (
    <div className="hhm-hero">
      <div className="hhm-hero__bg"></div>
      <div className="hhm-hero__overlay"></div>

      <div className="hhm-hero__content">
        <p className="hhm-hero__eyebrow">
          <span className="hhm-eyebrow-rule"></span>
          Modern Jewish Dating
        </p>
        <h1 className="hhm-hero__title">Jewish People,<br />All Backgrounds,<br />Everywhere.</h1>
        <p className="hhm-hero__body">Less Wasting Time, More Real Connections</p>

        <div className="hhm-hero__actions">
          <button
            className="hhm-btn-start"
            onClick={() => navigate("/register")}
          >
            Get Started
          </button>
          <div className="hhm-signin-row">
            <span className="hhm-signin-label">Already have an account?</span>
            <button
              className="hhm-btn-signin"
              onClick={() => navigate("/login")}
            >
              Sign in
            </button>
          </div>
        </div>

        <p className="hhm-hero__legal">
          By tapping <strong>Get Started</strong> you agree with our{' '}
          <Link to="/terms-of-service" className="hhm-hero__legal-link">Terms.</Link>{' '}
          See how we process your data in our{' '}
          <Link to="/privacy-policy" className="hhm-hero__legal-link">Privacy Policy.</Link>
        </p>
      </div>
    </div>
  );
};

export default SectionOneMobile;
